
export const amountList = [
  { key: 'notTakenTotalAmount', text: '待出商品总金额', num: '-', multiple: 0.01, toFixed: 3 },
  { key: 'notTakenTotalQuantity', text: '待出商品总数', num: '-' },
  { key: 'notReturnTotalAmount', text: '待退商品总金额', num: '-', multiple: 0.01, toFixed: 3},
  { key: 'notReturnTotalQuantity', text: '待退商品总数', num: '-' },
]

export const btnList = [
  { text: "批量改供货价", eventName: 'batchEditPrice' },
  // { text: "打印标签", eventName: 'printLabel' },
]

// 商品是否匹配
export const IS_MATE_LIST = [
  { label: '是', value: 1 },
  { label: '否', value: 0 }
];
// 供货价是否待审核
export const IS_CHECK_LIST = [
  { label: '是', value: 0 },
  { label: '否', value: 1 }
];


export const searchList = [
  // { prop: 'isSkuMatched', type: 'select', attrs: { placeholder: '匹配ERP商品', width: '140px', clearable: true }, items: IS_MATE_LIST },
  { prop: 'isApproval', type: 'select', attrs: { placeholder: '改价是否待审核', width: '140px', clearable: true }, items: IS_CHECK_LIST },
  {
    prop: 'itemOuterIdList',
    type: 'input',
    attrs: { placeholder: '多个款式编码，以英文逗号分割', width: '240px', label: '款式编码', isDialog: true },
  },
  {
    prop: 'outerIdList',
    type: 'input',
    attrs: {
      placeholder: '多个商品编码，以英文逗号分割',
      label: '商品编码',
      width: '240px',
      isDialog: true,
    },
  },
  {
    prop: 'text',
    type: 'input',
    attrs: {
      placeholder: '请输入商品名',
    },
  },
]
export const colList = [
  { prop: 'picPath', attrs: { label: '图片', width: 60, align: 'center' }, slot: true },
  { prop: 'itemOuterId', attrs: { label: '款式编码', width: 160, 'show-overflow-tooltip': true } },
  { prop: 'outerId', attrs: { label: '商品编码', width: 160, 'show-overflow-tooltip': true } },
  { prop: 'title', attrs: { label: '商品名', width: 200}, slot: true },
  { prop: 'notTakenAmount', attrs: { label: '待拿商品金额', width: 120, align: 'right' }, slot: true },
  { prop: 'notTakenQuantity', attrs: { label: '商品总数', width: 100, align: 'center' } },
  { prop: 'notReturnAmount', attrs: { label: '待退商品金额', width: 120, align: 'center' } },
  { prop: 'notReturnQuantity', attrs: { label: '待退商品数', width: 100, align: 'center' } },
  { prop: 'purchasePrice', attrs: { label: '供货价', width: 180, align: 'right', 'header-tooltip': '商品来自多个采购单，可能不同供货价，有多个时去重显示', 'show-overflow-tooltip': true }, slot: true },
  { prop: 'opcols', attrs: { label: '操作', width: 280, align: 'center' }, slot: true },
]
